import { PERMISSION_KEYS, PERMISSION_LABELS, type PermissionSet } from '../api/types'

/** Ten checkboxes. Controlled; the caller owns the value. */
export function PermissionEditor({
  value,
  onChange,
  disabled,
  idPrefix,
}: {
  value: PermissionSet
  onChange: (next: PermissionSet) => void
  disabled?: boolean
  idPrefix: string
}) {
  return (
    <div className="perm-grid">
      {PERMISSION_KEYS.map((key) => (
        <label key={key} className="perm-cell" htmlFor={`${idPrefix}-${key}`}>
          <input
            id={`${idPrefix}-${key}`}
            type="checkbox"
            checked={value[key]}
            disabled={disabled}
            onChange={(e) => onChange({ ...value, [key]: e.target.checked })}
          />
          <span>{PERMISSION_LABELS[key]}</span>
        </label>
      ))}
    </div>
  )
}

/** The bits as a compact row of chips, for lists. */
export function PermissionChips({ value }: { value: PermissionSet }) {
  const granted = PERMISSION_KEYS.filter((k) => value[k])
  if (granted.length === 0) return <span className="muted small">none</span>
  return (
    <ul className="chips" aria-label="Permissions">
      {granted.map((k) => (
        <li key={k} className="chip">
          {PERMISSION_LABELS[k]}
        </li>
      ))}
    </ul>
  )
}
